import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Close } from 'UI/Icons';
var customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: '100000'
  },
  content: {
    backgroundColor: 'transparent',
    border: '0',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    padding: '0',
    minHeight: '100%',
    overflow: 'auto',
    zIndex: '100000',
    WebkitOverflowScrolling: 'touch'
  }
};
Modal.setAppElement('#root');

var ModalObject = /*#__PURE__*/function (_Component) {
  _inherits(ModalObject, _Component);

  var _super = _createSuper(ModalObject);

  function ModalObject() {
    var _this;

    _classCallCheck(this, ModalObject);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onModalClick", function (e) {
      e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "shouldClose", function () {
      if (_this.props.isOpen && !_this.props.overridePrompt) {
        swal.fire({
          title: _this.props.translate('are-you-sure'),
          text: _this.props.translate('close-form-prompt'),
          showCancelButton: true,
          cancelButtonText: _this.props.translate('No'),
          confirmButtonText: _this.props.translate('Yes')
        }).then(function (result) {
          if (result.value != null) {
            if (_this.props.onClose != null && typeof _this.props.onClose == 'function') {
              _this.props.onClose();
            }
          }
        });
      } else {
        if (_this.props.onClose != null && typeof _this.props.onClose == 'function') {
          _this.props.onClose();
        }
      }
    });

    return _this;
  }

  _createClass(ModalObject, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        parentSelector: function parentSelector() {
          return document.querySelector('#modals');
        },
        isOpen: this.props.isOpen,
        onRequestClose: this.shouldClose,
        contentLabel: "",
        style: _objectSpread(_objectSpread({}, customStyles), this.props.style)
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.type ? "modal-overlay ".concat(this.props.type) : 'modal-overlay',
        onClick: this.shouldClose
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.type ? "modal-container ".concat(this.props.type) : 'modal-container',
        onClick: this.onModalClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h2", null, this.props.title)), this.props.onClose != null ? /*#__PURE__*/React.createElement("div", {
        className: "close",
        onClick: this.props.onClose
      }, /*#__PURE__*/React.createElement(Close, null)) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.props.children))));
    }
  }]);

  return ModalObject;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(ModalObject);